'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Sila pilih masa'
};

exports['default'] = locale;